<template>
    <div class="register">
        <van-form @submit="onSubmit">
            <img :src="formset.banner" v-if="formset && formset.banner" />
            <h4 class="title">{{ formset.title }}</h4>
            <div class="des">{{ formset.content }}</div>
            <div v-for="(item, index) in fieldArr" :key="index">
                <div v-html="item.column_content" v-if="item.column_type == 2"></div>
                <van-radio-group v-if="item.column_type == '2'" v-model="user[item.column_name]">
                    <van-radio shape="square" name="1">同意(agree)上方 <span>{{ item.column_title }}</span></van-radio>
                </van-radio-group>
                <van-cell-group :class="item.is_must ? 'required' : ''" v-else>
                    <van-field v-if="item.column_type == '0'" v-model="user[item.column_name]" :name="item.column_name"
                        :placeholder="item.column_placeholder"
                        :rules="[{ required: item.is_must, message: item.column_placeholder, trigger: 'blur' }]">
                    </van-field>
                    <van-field v-if="item.column_type == '1'" v-model="user[item.column_name]" :name="item.column_name"
                        :placeholder="item.column_placeholder"
                        :rules="[{ required: item.is_must, message: item.column_placeholder, trigger: 'blur' }]"
                        type="textarea">
                    </van-field>
                    <van-field v-if="item.column_type == '3'" :ref="item.column_name" readonly clickable
                        :value="user[item.column_name]" :name="item.column_name" :placeholder="item.column_placeholder"
                        :rules="[{ required: item.is_must, message: item.column_placeholder }]"
                        @click="changeShow(item.column_name)" />
                    <van-popup v-model="showPicker[item.column_name]" position="bottom" v-if="item.column_type == '3'">
                        <van-picker show-toolbar :columns="columns[item.column_name]"
                            @confirm="onConfirm(item.column_name, $event)" @cancel="changeShow(item.column_name)" />
                    </van-popup>
                </van-cell-group>
            </div>
            <p class="state">注意 :<span> * </span>为必填项</p>
            <div class="buttonGroup" ref='buttonGroup'>
                <van-button type="default" native-type="submit" :color="color">确定</van-button>

            </div>
        </van-form>
    </div>
</template>
<script>
import { Register, SendCode, BindMobile, PersoanalUserInfo, MeetingsSumbitInfo } from '../../config/interface.js'
import Areas from '../../assets/js/area.js'
export default {
    props: {
        fieldArr: Array,
        formset: Object,
        mobile:Number,
        meetingId: String
    },
    data() {
        return {

            bindStatus: true,
            closeOverlay: false,
            infostatus: false,
            areavalue: '',
            showArea: false,
            parent_id: 0,    //默认0   请求的是省份
            areaList: Areas, // 数据格式见 Area 组件文档
            isReSend: true,   //是否重新发送
            countdown: 60,     //倒计时
            sendTimeText: '获取验证码',
            user: {
            },
            showPicker: {},
            columns: {},
            color:'#901D22'
        }
    },
    mounted() {
        if(this.meetingId==711){
            this.color='#002E65'
        }
        // console.log(this.color)
        this.user = {};
        this.fieldArr.forEach((item, index) => {
            // 优先使用字段自带的默认值
            if (item.column_value) {
                this.$set(this.user, item.column_name, item.column_value.toString());
            } else {
                // 如果没有默认值，设置为空字符串
                this.$set(this.user, item.column_name, '');
            }
            if (item.column_type == '3') {
                this.$set(this.showPicker, item.column_name, false)
                this.fieldArr[index]['list'] = [];
                let list = [];
                for (let i = 0; i < this.fieldArr[index].options.length; i++) {
                    list.push(this.fieldArr[index].options[i].option);
                }
                this.$set(this.columns, item.column_name, list);
            }
            // if(item.column_name=='DH' && this.mobile){
            //     this.user[item.column_name]=this.mobile;
            // }
        })
    },
    watch: {
        showPicker: {
            deep: true,
            handler: function (newV, oldV) {

            }
        },
        columns: {
            deep: true,
            handler: function (newV, oldV) {

            }
        },
        mobile: {
            deep: true,
            handler: function (newV, oldV) {

            }
        }
    },
    methods: {
        onSubmit() {
            for (let i = 0; i < this.fieldArr.length; i++) {
                if (parseInt(this.fieldArr[i].column_type) == 2) {
                    if (this.user[this.fieldArr[i].column_name] && this.user[this.fieldArr[i].column_name] == '1') {
                        // this.user[item.column_name]=this.user[item.column_name][0];
                    }
                    else {
                        common.toast('请勾选同意(agree)按钮', 2000);
                        return
                    }
                }
            }
            const url = MeetingsSumbitInfo;

            let params = {
                meeting_id: this.$route.query.meeting_id ? this.$route.query.meeting_id : this.$route.query.MT_id,
                user_extend_columns: this.user
            }
            const method = 'POST';
            fetch(url, params, method)
                .then((res) => {
                    if (res.code == 0) {
                        if (res.data.not_allow == 1) {
                            this.$emit('changeAuth', false)
                            this.$emit('func', this.infostatus);
                            // common.toast('您无权限观看本会议',1000);
                        }
                        else {
                            common.toast('提交成功', 1000);
                            setTimeout(() => {
                                this.$emit('func', this.infostatus);
                                this.$emit('changeAuth', true);
                            }, 2000)
                        }
                    }
                })
        },
        onConfirm(name, value) {
            this.$set(this.showPicker, name, false);
            this.user[name] = value;
            //  this.user[item.column_name]=val;
        },
        changeShow(name) {
            this.$set(this.showPicker, name, !this.showPicker[name])

        },
    }
}
</script>
<style lang="scss">
.register {
    width: 320px;
    padding: 30px 20px 15px;
    box-sizing: border-box;

    img {
        width: 100%;
    }

    .title {
        text-align: center;
        padding: 10px 0;
        font-size: 16px;
    }

    .des {
        color: #999;
        padding: 10px 0;
        font-size: 14px;
    }

    .close {
        position: absolute;
        top: 10px;
        right: 10px;
        font-size: 20px;
    }

    h2 {
        font-size: 20px;
        color: #901d22;
        text-align: center;
        margin-bottom: 20px;
    }

    .van-radio-group {
        margin-bottom: 15px;

        span {
            font-weight: bold
        }
    }

    .van-cell-group {
        display: flex;
        align-items: center;
        font-size: 15px;
        margin-bottom: 15px;

        .van-cell {
            // border:1px solid #ddd;
            background: rgba(86, 86, 86, 0.03);
            border-radius: 10px;
            padding: 10px 15px;
        }

        .van-cell:not(:last-child)::after {
            border: 0px;
        }
    }

    .van-cell-group.address_info {
        margin-bottom: 7px;
    }

    .van-cell-group:before {
        display: inline-block;
        vertical-align: middle;
        content: '*';
        margin-right: 5px;
        color: #fff;
    }

    .van-cell-group.required:before {
        color: red;
    }

    .van-cell-group:after {
        border: 0px;
    }

    button.sendCode {
        border-radius: 0 10px 10px 0;
        font-size: 12px;
        width: 140px;
        border: 0px;
        color: $color-main;
        background: #fff;
        // border-left:1px solid $color-main;
    }

    .buttonGroup {
        width: 100%;
        display: flex;
        justify-content: space-around;
        margin-top: 20px;

        button {
            width: 134px;
            height: 40px;
            color: #fff;
            background: rgba(154, 154, 154, 1);
            border-radius: 23px;
            font-size: 17px;
        }

        button:last-child {
            background: #901D22;
        }
    }

    .success {
        padding: 35px 15px;
        text-align: center;

        img {
            width: 7rem;
        }

        h1 {
            margin: 0 0 10px;
            font-size: 17px;
            letter-spacing: 1px;
            color: #090909;
        }

        p {
            color: #999;
            font-size: 13px;
        }
    }

    .state {
        margin-left: 10px;

        span {
            color: red;
        }
    }

}
</style>


// WEBPACK FOOTER //
// src/components/Meeting/CollectInfo.vue